import { sliceKeys } from './constants';
import { selectors as companies } from './companies';
import { selectors as cities } from './cities';
import { selectors as houses } from './houses';
import { selectors as rooms } from './rooms';
import { selectors as relatedRooms } from './relatedRooms';
import { selectors as desks } from './desks';
import { selectors as create } from './acceptanceCreate';
import { selectors as attachmentsFilter } from './attachmentsFilter';

export const selectors = {
  [sliceKeys.companies]: companies,
  [sliceKeys.cities]: cities,
  [sliceKeys.houses]: houses,
  [sliceKeys.rooms]: rooms,
  [sliceKeys.relatedRooms]: relatedRooms,
  [sliceKeys.desks]: desks,
  [sliceKeys.createPage]: create,
  [sliceKeys.attachmentsFilter]: attachmentsFilter,
};
